import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
// import AutocompleteSelectMenu from "@saleor/components/AutocompleteSelectMenu";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import SingleAutocompleteSelectField from "@saleor/components/SingleAutocompleteSelectField";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { MenuErrorFragment } from "@saleor/fragments/types/MenuErrorFragment";
import useModalDialogErrors from "@saleor/hooks/useModalDialogErrors";
// import useModalDialogOpen from "@saleor/hooks/useModalDialogOpen";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import {
  buttonMessages
  // sectionNames
} from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { SearchCategories_search_edges_node } from "@saleor/searches/types/SearchCategories";
import { SearchCollections_search_edges_node } from "@saleor/searches/types/SearchCollections";
import { SearchMenuItems_search_edges_node } from "@saleor/searches/types/SearchMenuItems";
import { SearchPages_search_edges_node } from "@saleor/searches/types/SearchPages";
import { FetchMoreProps } from "@saleor/types";
import { MenuBannerTypeEnum } from "@saleor/types/globalTypes";
import {
  // getFieldError,
  getFormErrors
} from "@saleor/utils/errors";
import getMenuErrorMessage from "@saleor/utils/errors/menu";
// import { getMenuItemByValue, IMenu } from "@saleor/utils/menu";
// import isUrl from "is-url";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import BannerMediasDialog from "../BannerMediasDialog";

export type MenuItemType = "category" | "collection" | "link" | "page";
// export interface MenuItemData {
//   id: string;
//   type: MenuItemType;
// }

export interface MenuItemDetailsImageBanners {
  type: MenuBannerTypeEnum;
  id: string;
  title: string;
  subtitle: string;
  url: string;
  pcImageUrl: string;
  h5ImageUrl: string;
}

// export interface MenuItemDialogFormData extends MenuItemData {
//   name: string;
//   thumbnailUrl: string;
//   carouselBanners:MenuItemDetailsImageBanners[];
//   imageBanners:MenuItemDetailsImageBanners[];
// }
export interface MenuItemDialogFormData {
  url: string;
  name: string;
  thumbnailUrl: string;
  mbThumbnailUrl: string;
  cellNumber: number;
  textColor: string;
  parentId: string;
  isTop: boolean;
  isShowName: boolean;
  carouselBanners: MenuItemDetailsImageBanners[];
  imageBanners: MenuItemDetailsImageBanners[];
}

export interface MenuItemDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  disabled: boolean;
  errors: MenuErrorFragment[];
  initial?: MenuItemDialogFormData;
  initialDisplayValue?: string;
  loading: boolean;
  open: boolean;
  collections: SearchCollections_search_edges_node[];
  categories: SearchCategories_search_edges_node[];
  pages: SearchPages_search_edges_node[];
  onClose: () => void;
  onSubmit: (data: MenuItemDialogFormData) => void;
  onQueryChange: (query: string) => void;
  fetchParents: (query: string) => void;
  fetchMoreParents: FetchMoreProps;
  parentsList: SearchMenuItems_search_edges_node[];
}
export const defaultImageData: MenuItemDetailsImageBanners = {
  type: MenuBannerTypeEnum.IMAGE,
  id: "",
  title: "",
  subtitle: "",
  url: "",
  pcImageUrl: "",
  h5ImageUrl: ""
};

export const defaultCarouselData: MenuItemDetailsImageBanners = {
  type: MenuBannerTypeEnum.CAROUSEL,
  id: "",
  title: "",
  subtitle: "",
  url: "",
  pcImageUrl: "",
  h5ImageUrl: ""
};

export const defaultInitial: MenuItemDialogFormData = {
  // id: "",
  thumbnailUrl: "",
  mbThumbnailUrl: "",
  url: "",
  name: "",
  cellNumber: 0,
  textColor: "",
  isTop: false,
  isShowName: false,
  parentId: "",
  // type: "category",
  carouselBanners: [defaultCarouselData],
  imageBanners: [defaultImageData]
};

// function getMenuItemData(value: string): MenuItemData {
//   console.log(value,"值")
//   const [type, ...idParts] = value.split(":");
//   console.log(type,idParts,"类型和id")
//   return {
//     id: idParts.join(":"),
//     type: type as MenuItemType
//   };
// }

// function getDisplayValue(menu: IMenu, value: string): string {
//   const menuItemData = getMenuItemData(value);
//   if (menuItemData.type === "link") {
//     return menuItemData.id;
//   }
//   return getMenuItemByValue(menu, value).label.toString();
// }

const MenuItemDialog: React.FC<MenuItemDialogProps> = ({
  confirmButtonState,
  disabled,
  errors: apiErrors,
  initial,
  initialDisplayValue,
  // loading,
  onClose,
  onSubmit,
  // onQueryChange,
  open,
  // categories,
  // collections,
  // pages
  // parent下拉框
  parentsList,
  fetchParents,
  fetchMoreParents
}) => {
  const intl = useIntl();
  const errors = useModalDialogErrors(apiErrors, open);
  const [displayValue, setDisplayValue] = React.useState(
    initialDisplayValue || ""
  );
  const [data, setData] = useStateFromProps<MenuItemDialogFormData>(
    initial || defaultInitial
  );
  const inputTypeChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "Default",
        description: "Default"
      }),
      value: "0"
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Number of Columns:2",
        description: "Number of Columns:2"
      }),
      value: "2"
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Number of Columns:3",
        description: "Number of Columns:3"
      }),
      value: "3"
    }
  ];
  // console.log(data,"初始数据是什么")
  // const [url, setUrl] = React.useState<string>(undefined);

  // Reset input state after closing dialog
  // useModalDialogOpen(open, {
  //   onClose: () => {
  //     setData(initial || defaultInitial);
  //     setDisplayValue(initialDisplayValue);
  //     setUrl(undefined);
  //   }
  // });

  // Refresh initial display value if changed
  React.useEffect(() => setDisplayValue(initialDisplayValue), [
    initialDisplayValue
  ]);

  const mutationErrors = errors.filter(err => err.field === null);
  const formErrors = getFormErrors(["name"], errors);
  // const idError = ["category", "collection", "page", "url"]
  //   .map(field => getFieldError(errors, field))
  //   .reduce((acc, err) => acc || err);

  // let options: IMenu = [];

  // if (categories.length > 0) {
  //   options = [
  //     ...options,
  //     {
  //       children: categories.map(category => ({
  //         children: [],
  //         data: {},
  //         label: category.name,
  //         value: "category:" + category.id
  //       })),
  //       data: {},
  //       label: intl.formatMessage(sectionNames.categories)
  //     }
  //   ];
  // }

  // if (collections.length > 0) {
  //   options = [
  //     ...options,
  //     {
  //       children: collections.map(collection => ({
  //         children: [],
  //         data: {},
  //         label: collection.name,
  //         value: "collection:" + collection.id
  //       })),
  //       data: {},
  //       label: intl.formatMessage(sectionNames.collections)
  //     }
  //   ];
  // }

  // if (pages.length > 0) {
  //   options = [
  //     ...options,
  //     {
  //       children: pages.map(page => ({
  //         children: [],
  //         data: {},
  //         label: page.title,
  //         value: "page:" + page.id
  //       })),
  //       data: {},
  //       label: intl.formatMessage(sectionNames.pages)
  //     }
  //   ];
  // }

  // if (url) {
  //   options = [
  //     {
  //       children: [],
  //       data: {},
  //       label: (
  //         <FormattedMessage
  //           defaultMessage="Link to: {url}"
  //           description="add link to navigation"
  //           id="menuItemDialogAddLink"
  //           values={{
  //             url: <strong>{url}</strong>
  //           }}
  //         />
  //       ),
  //       value: "link:" + url
  //     }
  //   ];
  // }

  // const handleQueryChange = (query: string) => {
  //   if (isUrl(query)) {
  //     setUrl(query);
  //   } else if (isUrl("http://" + query)) {
  //     setUrl("http://" + query);
  //   } else if (url) {
  //     setUrl(undefined);
  //   }
  //   onQueryChange(query);
  // };

  // const handleSelectChange = (event: React.ChangeEvent<any>) => {
  //   const value = event.target.value;
  //   const menuItemData = getMenuItemData(value);

  //   setData(value => ({
  //     ...value,
  //     ...menuItemData
  //   }));
  //   setDisplayValue(getDisplayValue(options, value));
  // };

  const handleSubmit = async () => {
    await setData(value => {
      const data = {
        ...value,
        imageBanners: imageFromData,
        carouselBanners: carouselFromData
      };
      onSubmit(data);
      return data;
    });
  };

  const imageBanners = [];
  if (data?.imageBanners.length === 0) {
    // imageBanners.push(defaultImageData);
  } else {
    // eslint-disable-next-line no-unused-expressions
    data?.imageBanners.map(item => {
      // eslint-disable-next-line dot-notation
      delete item["__typename"];
      imageBanners.push(item);
    });
  }
  const [imageFromData, setImageFromData] = useStateFromProps<
    MenuItemDetailsImageBanners[]
  >(imageBanners);

  const carouselBanners = [];
  if (data?.carouselBanners.length === 0) {
    // carouselBanners.push(defaultCarouselData);
  } else {
    // eslint-disable-next-line no-unused-expressions
    data?.carouselBanners.map(item => {
      // eslint-disable-next-line dot-notation
      delete item["__typename"];
      carouselBanners.push(item);
    });
  }
  const [carouselFromData, setCarouselFromData] = useStateFromProps<
    MenuItemDetailsImageBanners[]
  >(carouselBanners);

  function addNewItem(list, type) {
    if (type === "IMAGE") {
      setImageFromData(data => {
        const arr = [...data];
        arr[list.length] = {
          ...defaultImageData
        };
        return arr;
      });
    } else {
      setCarouselFromData(data => {
        const arr = [...data];
        arr[list.length] = {
          ...defaultCarouselData
        };
        return arr;
      });
    }
    return list;
  }

  function deleteItem(id, type, index) {
    if (type === "IMAGE") {
      setImageFromData(data => {
        const arr = [...data];
        arr[index] = {
          type: null,
          id,
          title: null,
          subtitle: null,
          url: null,
          pcImageUrl: null,
          h5ImageUrl: null
        };
        return arr;
      });
    } else {
      setCarouselFromData(data => {
        const arr = [...data];
        arr[index] = {
          type: null,
          id,
          title: null,
          subtitle: null,
          url: null,
          pcImageUrl: null,
          h5ImageUrl: null
        };
        return arr;
      });
    }
  }

  const parents = maybe(() => parentsList, []).map(parent => ({
    label: parent.name,
    value: parent.id
  }));

  const [selectedParent, setSelectedParent] = useStateFromProps("");

  return (
    <Dialog
      // onClose={onClose}
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: { overflowY: "visible", height: "700px" }
      }}
      scroll={"body"}
    >
      <DialogTitle style={{ height: "70px" }}>
        {!!initial
          ? intl.formatMessage({
              defaultMessage: "Edit Item",
              description: "edit menu item, header",
              id: "menuItemDialogEditItem"
            })
          : intl.formatMessage({
              defaultMessage: "Add Item",
              description: "create new menu item, header",
              id: "menuItemDialogAddItem"
            })}
      </DialogTitle>
      <DialogContent style={{ overflowY: "scroll", height: "550px" }}>
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Name",
            description: "menu item name",
            id: "menuItemDialogNameLabel"
          })}
          fullWidth
          value={data.name}
          onChange={event => {
            event.persist();
            setData(value => ({
              ...value,
              name: event.target.value
            }));
          }}
          name="name"
          error={!!formErrors.name}
          helperText={getMenuErrorMessage(formErrors.name, intl)}
        />
        <FormSpacer />
        <ControlledCheckbox
          name="isShowName"
          label={intl.formatMessage({
            defaultMessage: "IS Show Name",
            description: "IS Show Name"
          })}
          checked={data.isShowName}
          onChange={event => {
            setData(value => ({
              ...value,
              isShowName: event?.target?.value
            }));
          }}
          disabled={disabled}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "PC Thumbnail Url",
            description: "menu item thumbnail url",
            id: "menuItemDialogNameLabel"
          })}
          fullWidth
          value={data.thumbnailUrl}
          onChange={event => {
            event.persist();
            setData(value => ({
              ...value,
              thumbnailUrl: event?.target?.value
            }));
          }}
          name="thumbnailUrl"
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "MB Thumbnail Url",
            description: "menu item thumbnail url",
            id: "menuItemDialogNameLabel"
          })}
          fullWidth
          value={data.mbThumbnailUrl}
          onChange={event => {
            event.persist();
            setData(value => ({
              ...value,
              mbThumbnailUrl: event?.target?.value
            }));
          }}
          name="mbThumbnailUrl"
        />
        <FormSpacer />
        {/* <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Cell Number",
            description: "menu item Cell Number",
            id: "menuItemDialogNameLabel"
          })}
          fullWidth
          value={data.cellNumber}
          onChange={event => {
            event.persist();
            setData(value => ({
              ...value,
              cellNumber: Number(event?.target?.value)
            }));
          }}
          name="cellNumber"
        /> */}
        <SingleSelectField
          choices={inputTypeChoices}
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Thumbnail Display Columns",
            description: "Thumbnail Display Columns"
          })}
          name={"cellNumber"}
          onChange={event => {
            event.persist();
            setData(value => ({
              ...value,
              cellNumber: Number(event?.target?.value)
            }));
          }}
          value={String(data.cellNumber)}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Text Color",
            description: "menu item Text Color",
            id: "menuItemDialogNameLabel"
          })}
          fullWidth
          value={data.textColor}
          onChange={event => {
            event.persist();
            setData(value => ({
              ...value,
              textColor: event?.target?.value
            }));
          }}
          name="textColor"
        />
        <FormSpacer />
        <ControlledCheckbox
          name="isTop"
          label={intl.formatMessage({
            defaultMessage: "IS Top",
            description: "IS Top"
          })}
          checked={data.isTop}
          onChange={event => {
            setData(value => ({
              ...value,
              isTop: event?.target?.value
            }));
          }}
          disabled={disabled}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Link",
            description: "label",
            id: "menuItemDialogLinkLabel"
          })}
          fullWidth
          value={displayValue}
          onChange={event => {
            event.persist();
            setData(value => ({
              ...value,
              url: event?.target?.value
            }));
            setDisplayValue(event.target.value);
          }}
          // onChange={event =>{
          //   const value1 = event.target.value;
          //   const menuItemData = getMenuItemData(value1);

          //   setData(value => ({
          //     ...value,
          //     ...menuItemData
          //   }));
          //   setDisplayValue(event.target.value);
          //   }
          // }
          name="Link"
        />
        {/* <AutocompleteSelectMenu
          disabled={disabled}
          onChange={handleSelectChange}
          name="id"
          label={intl.formatMessage({
            defaultMessage: "Link",
            description: "label",
            id: "menuItemDialogLinkLabel"
          })}
          displayValue={displayValue}
          loading={loading}
          options={options}
          error={!!idError}
          helperText={getMenuErrorMessage(idError, intl)}
          placeholder={intl.formatMessage({
            defaultMessage: "Start typing to begin search...",
            id: "menuItemDialogLinkPlaceholder"
          })}
          onInputChange={handleQueryChange}
        /> */}
        <FormSpacer />
        {!!!initial && (
          <SingleAutocompleteSelectField
            displayValue={parents ? selectedParent : ""}
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Parent"
            })}
            choices={disabled ? [] : parents}
            name="parent"
            value={data?.parentId}
            onChange={event => {
              setData(value => ({
                ...value,
                parentId: event?.target?.value
              }));
              const value = event.target.value;
              const choice = parents.find(category => category.value === value);
              setSelectedParent(choice ? choice.label : value);
            }}
            fetchChoices={fetchParents}
            emptyOption={true}
            {...fetchMoreParents}
          />
        )}
        <FormSpacer />
        {false && (
          <BannerMediasDialog
            imageFromData={imageFromData}
            setImageFromData={setImageFromData}
            carouselFromData={carouselFromData}
            setCarouselFromData={setCarouselFromData}
            disabled={disabled}
            addNewItem={addNewItem}
            deleteItem={deleteItem}
          />
        )}
        {mutationErrors.length > 0 && (
          <>
            <FormSpacer />
            {mutationErrors.map(err => (
              <Typography key={err.code} color="error">
                {getMenuErrorMessage(err, intl)}
              </Typography>
            ))}
          </>
        )}
      </DialogContent>
      <DialogActions style={{ height: "80px" }}>
        <Button onClick={onClose}>
          <FormattedMessage {...buttonMessages.back} />
        </Button>
        <ConfirmButton
          transitionState={confirmButtonState}
          color="primary"
          variant="contained"
          onClick={handleSubmit}
        >
          <FormattedMessage {...buttonMessages.confirm} />
        </ConfirmButton>
      </DialogActions>
    </Dialog>
  );
};
export default MenuItemDialog;
